import React, { useState } from 'react'
import styled from 'styled-components'
import { IRadioFilter } from '../../interfaces/directory-filters'
import { FilterContainer } from '../FilterContainer/FilterContainer'

const FilterOption = styled.div`
  display: flex;
  align-items: baseline;
`

export interface IRadioFilterProps {
  onChange: Function
  filter: IRadioFilter
  [x: string]: any
}

export const RadioFilter: React.FC<IRadioFilterProps> = ({
  onChange,
  filter,
  ...p
}) => {
  const [internalFilter, setInternalFilter] = useState({ ...filter })
  const [showDropdown, setShowDropdown] = useState(false)

  const onValueChange = (value: string) => {
    const newFilter = {
      ...JSON.parse(JSON.stringify(filter)),
      value: isNaN(Number(value)) ? value : Number(value)
    }

    setInternalFilter(newFilter)
  }

  const apply = () => {
    onChange(internalFilter.value)
    setShowDropdown(false)
  }

  const onToggle = () => {
    setInternalFilter({ ...filter })
    setShowDropdown(!showDropdown)
  }

  return (
    <FilterContainer
      name={filter.name}
      apply={apply}
      onToggle={onToggle}
      showDropdown={showDropdown}
      appliedFilters={true}
      dropdownMenuStyle={{
        overflowY: 'auto'
      }}
      {...p}
    >
      {filter.options.map((o) => (
        <FilterOption key={o.label}>
          <input
            name={filter.name}
            checked={internalFilter.value === o.value}
            value={o.value}
            onChange={(e) => onValueChange(e.target.value)}
            id={o.label}
            type="radio"
            style={{ marginRight: '7px' }}
          />
          <label htmlFor={o.label}>{o.label}</label>
        </FilterOption>
      ))}
    </FilterContainer>
  )
}

export default RadioFilter
